import React from 'react';
import { createRoot } from 'react-dom/client';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import './index.css';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
